import { EncryptStorage } from 'encrypt-storage';
const LS_ENCRYPTION_KEY = process.env.REACT_APP_LS_ENCRYPTION_KEY;
if (!LS_ENCRYPTION_KEY) {
    throw new Error('LS_ENCRYPTION_KEY is not set');
}
export const ls = new EncryptStorage(LS_ENCRYPTION_KEY, {});
